import { NgModule } from '@angular/core';

import { CostAppConfigService } from './cost-app-config.service';
import { InstanceModule } from "libraries/service/instance/instance.module";

@NgModule({
    imports: [
        InstanceModule
    ],
    providers: [
        CostAppConfigService
    ],
})
export class CostAppConfigModule { }
